const PageFooter = ( { data }) => {
    return (
        <div className="page-footer-outer">
            <div className="page-footer-inner">
                <h2>{data.footerHeading}</h2>
                <div className="footer-ctas">
                    <ul className="nostyle ctas-list">
                        {data.footerCTAs.map((c, i) => {
                            return (
                                <li key={c.id} className="footer-cta">
                                    <a
                                        className="footer-cta-link large-button cta-button"
                                        href={c.footerCTALink}
                                        target="_blank" rel="noopener noreferrer"
                                    >
                                        {c.footerCTA}
                                    </a>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default PageFooter
